import styled from 'styled-components';

import { pxToRem } from 'utils/convert';

import { Skeleton } from 'ui/skeleton';
import { colors, fontSizes, spacing } from 'ui/theme';

import { EventsList } from './EventsList';
import { useUserMetadataQueryContext } from '../../contexts/UserMetadataQueryContext';
import { GridArea } from '../constants';

const displayText = {
  title: 'Recent events',
};

const Title = styled.div`
  font-size: ${fontSizes.s16};
  margin-bottom: ${spacing.half};
  grid-area: ${GridArea.recentEventsTitle};
`;

const TitleSkeleton = styled(Skeleton)`
  width: ${pxToRem(100)};
  height: ${fontSizes.s24};
  margin-bottom: ${spacing.half};
  background-color: ${colors.grey5};
  grid-area: ${GridArea.recentEventsTitle};
`;

const EventsListSkeleton = styled(Skeleton)`
  width: ${pxToRem(336)};
  height: ${pxToRem(156)};
  background-color: ${colors.grey5};
  grid-area: ${GridArea.recentEventsList};
`;

export const RecentEvents = () => {
  const { isLoading } = useUserMetadataQueryContext();

  if (isLoading) {
    return (
      <>
        <TitleSkeleton />
        <EventsListSkeleton />
      </>
    );
  }

  return (
    <>
      <Title>{displayText.title}</Title>
      <EventsList />
    </>
  );
};
